export default {
  state: {
    jwt: null,
    tabOptions: [],
    activeIndex: '',
    showName: '',
    role: ''
  },
  getters: {
    getJwt: (state) => {
      return state.jwt
    },
    getShowName: (state) => {
      return state.showName
    },
    getTabOptions: (state) => {
      return state.tabOptions
    },
    getRole: (state) => {
      return state.role
    },
    getActiveIndexs: (state) => {
      return state.activeIndex
    }
  },
  mutations: {
    setJwt: (state, payload) => {
      state.jwt = payload.jwt
    },
    // 添加tabs
    add_tabs(state, data) {
      state.tabOptions.push(data)
    },
    // 删除tabs
    delete_tabs(state, route) {
      let index = 0
      for (const option of state.tabOptions) {
        if (option.route === route) {
          break
        }
        index++
      }
      state.tabOptions.splice(index, 1)//删除options里面下标为Index的一个数
    },
    // 设置当前激活的tab
    set_active_index(state, index) {
      state.activeIndex = index
    },
    //设置tab页显示标题
    set_showName(state, name) {
      state.showName = name
    },
    set_role(state, role) {
      this.state.role = role
    }
  },
  actions: {}
}
